export default __webpack_public_path__ + "static/media/u-16.7f97afee.png";